"use server";

import { prisma } from "@/lib/prisma";
import { Netgsm } from "@netgsm/sms";
import bcrypt from "bcryptjs";
import { formatPhoneNumber } from "@/utils/utils";
import { headers } from "next/headers";

export async function sendOtpAction(phoneNumber: string) {
    try {
        const headersList = await headers();
        const hostname = headersList.get("x-forwarded-host") || headersList.get("host") || "";
        const domain = hostname.split(":")[0];

        const site = await prisma.site.findUnique({
            where: { domain },
            select: { id: true }
        });

        if (!site) {
            return { success: false, message: "Site yapılandırması bulunamadı." };
        }

        const siteId = site.id;

        const formattedPhone = formatPhoneNumber(phoneNumber);

        const rawCode = Math.floor(100000 + Math.random() * 900000).toString();
        const hashedCode = await bcrypt.hash(rawCode, 10);
        const expiresAt = new Date(Date.now() + 3 * 60 * 1000);

        const integration = await prisma.siteIntegration.findUnique({
            where: { siteId }
        });

        const netgsm = new Netgsm({
            username: process.env.NETGSM_USER || "",
            password: process.env.NETGSM_PASS || "",
        });

        const response = await netgsm.sendRestSms({
            msgheader: integration?.smsHeader || process.env.NETGSM_DEFAULT_HEADER || "",
            encoding: 'TR',
            messages: [
                {
                    msg: `Dogrulama kodunuz: ${rawCode}. Bu kod 3 dakika gecerlidir.`,
                    no: formattedPhone
                }
            ]
        });

        if (!response || !response.jobid) {
            console.error("Netgsm Response Error:", response);
            return { success: false, message: "SMS servisinden yanıt alınamadı." };
        }

        await prisma.verificationCode.create({
            data: {
                siteId,
                phoneNumber: formattedPhone,
                code: hashedCode,
                expiresAt,
            },
        });

        return { success: true, message: "Kod gönderildi.", jobId: response.jobid };
    } catch (error) {
        console.error("SMS_SEND_ERROR:", error);
        return { success: false, message: "Teknik bir hata oluştu." };
    }
}

export async function verifyOtpAction(
    phoneNumber: string,
    userEnteredCode: string,
) {
    try {
        const headersList = await headers();
        const hostname = headersList.get("x-forwarded-host") || headersList.get("host") || "";
        const domain = hostname.split(":")[0];

        const site = await prisma.site.findUnique({
            where: { domain },
            select: { id: true }
        });

        if (!site) {
            return { success: false, message: "Site yapılandırması bulunamadı." };
        }

        const siteId = site.id;

        const formattedPhone = formatPhoneNumber(phoneNumber);

        const record = await prisma.verificationCode.findFirst({
            where: {
                phoneNumber: formattedPhone,
                siteId: siteId,
                isUsed: false,
                expiresAt: {
                    gt: new Date(),
                },
            },
            orderBy: {
                createdAt: "desc",
            },
        });

        if (!record) {
            return {
                success: false,
                message: "Geçerli bir doğrulama kodu bulunamadı veya süresi dolmuş."
            };
        }

        if (record.attempts >= 3) {
            return {
                success: false,
                message: "Çok fazla hatalı deneme yaptınız. Lütfen yeni bir kod isteyin."
            };
        }

        const isCodeValid = await bcrypt.compare(userEnteredCode, record.code);

        if (!isCodeValid) {
            await prisma.verificationCode.update({
                where: { id: record.id },
                data: {
                    attempts: { increment: 1 }
                },
            });

            return {
                success: false,
                message: `Kod hatalı. Kalan deneme hakkınız: ${2 - record.attempts}`
            };
        }

        // Aynı kodun ikinci kez kullanılmasını önler
        await prisma.verificationCode.update({
            where: { id: record.id },
            data: {
                isUsed: true
            },
        });

        return {
            success: true,
            message: "Telefon numarası başarıyla doğrulandı."
        };

    } catch (error) {
        console.error("VERIFY_OTP_ERROR:", error);
        return {
            success: false,
            message: "Doğrulama sırasında bir hata oluştu."
        };
    }
}